module.exports = "<div id=\"content-error-page\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-lg-8 col-lg-offset-2\">\n                <div class=\"logo\"></div>\n                <h1>Server Error</h1>\n                <p>There was a problem serving the requested page. We've been notified of the problem and will do our best to make sure it doesn't happen again.</p>\n                <a ui-sref=\"r.in.top.home\" class=\"btn btn-link\">Okay, take me Home</a>\n            </div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/500.html
// module id = 510
// module chunks = 0